import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageGlowContainer from '../components/PageLayout';
import ProfessionalPage from '../components/ProfessionalPage';
import SubsectionBoxes from '../components/SubsectionBoxes';
import {
  projectsColor,
  projectsDescription,
  projectsGithubLink,
  projectsHeading,
  projectsItems,
} from '../content/projectsContent';

const iconByKey = {
  battlebees: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={projectsColor}><circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" fill={projectsColor}/><text x="12" y="16" textAnchor="middle" fontSize="10" fill="#fff" fontFamily="monospace">BB</text></svg>
  ),
  pie: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={projectsColor}><circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" fill={projectsColor}/><path d="M12 12V2A10 10 0 0 1 20.66 17Z" fill="#fff" opacity="0.9"/><path d="M12 12L3.34 17A10 10 0 0 1 12 2Z" fill="#fff" opacity="0.45"/></svg>
  ),
  endpointexplorer: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={projectsColor}><rect x="3" y="6" width="18" height="12" rx="3" stroke="#fff" strokeWidth="2" fill={projectsColor}/><path d="M7 12h10" stroke="#fff" strokeWidth="2"/><circle cx="7" cy="12" r="1.5" fill="#fff"/><circle cx="17" cy="12" r="1.5" fill="#fff"/></svg>
  ),
  elevator: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={projectsColor}><rect x="6" y="3" width="12" height="18" rx="2" stroke="#fff" strokeWidth="2" fill={projectsColor}/><path d="M12 7v6M9 13l3 3 3-3" stroke="#fff" strokeWidth="2"/></svg>
  ),
  monopoly: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={projectsColor}><rect x="4" y="4" width="16" height="16" rx="4" stroke="#fff" strokeWidth="2" fill={projectsColor}/><circle cx="12" cy="12" r="4" fill="#fff"/><text x="12" y="16" textAnchor="middle" fontSize="8" fill={projectsColor} fontFamily="monospace">M</text></svg>
  ),
  soccer: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={projectsColor}><circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" fill={projectsColor}/><path d="M12 6v12M6 12h12" stroke="#fff" strokeWidth="2"/></svg>
  ),
};

const projectItemsWithIcons = projectsItems.map((item) => ({
  ...item,
  icon: iconByKey[item.iconKey],
}));

const Projects = ({ theme }) => {
  const navigate = useNavigate();

  if (theme === 'professional') {
    return (
      <ProfessionalPage title="Projects">
        <p>
          {projectsDescription}
          <a href={projectsGithubLink} className="professional-inline-link" target="_blank" rel="noopener noreferrer">
            GitHub
            <span className="new-tab-indicator" aria-hidden="true">↗</span>
          </a>.
        </p>
        <p>
          Want to play something new? Try out my multiplayer game{' '}
          <a href="https://battlebees.web.app/" className="professional-inline-link" target="_blank" rel="noopener noreferrer">
            BattleBees
            <span className="new-tab-indicator" aria-hidden="true">↗</span>
          </a>
          .
        </p>
        {projectsItems.map((project) => (
          <section key={project.title} className="professional-section">
            <h3>
              <a href={project.link} className="professional-project-title-link" target="_blank" rel="noopener noreferrer">
                {project.title}
                <span className="new-tab-indicator" aria-hidden="true">↗</span>
              </a>
            </h3>
            {project.descriptions.map((description, index) => (
              <p key={index}>{description}</p>
            ))}
          </section>
        ))}
      </ProfessionalPage>
    );
  }

  return (
    <>
      <div className="ddr-grid"></div>
      <PageGlowContainer title="My Projects" glowColor={projectsColor} className="blue-scroll" onEsc={() => navigate('/') }>
        <h2 className="projects-subheading" style={{ color: projectsColor, letterSpacing: 1 }}>{projectsHeading}</h2>
        <p className="projects-description">
          {projectsDescription}
          <a href={projectsGithubLink} className="projects-link" style={{ color: projectsColor }}>GitHub</a>.
        </p>
        <SubsectionBoxes items={projectItemsWithIcons} color={projectsColor} />
      </PageGlowContainer>
    </>
  );
};

export default Projects; 